export const environment: any = {
  production: true,
  configFilePath: 'assets/configuration/configuration.production.json',
  angularConfig: require('../../angular.json'),
  pwa: false,
  hmr: false
};

